module.exports = __webpack_public_path__ + "static/media/Logo.14507317.svg";